/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TrackingLine
 */
export interface TrackingLine {
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  trackingLineId: string;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  details?: string;
  /**
   * Pre-formatted timestamp.
   * @type {string}
   * @memberof TrackingLine
   */
  at?: string;
  /**
   * Where the line came from, in carrier-facing words — their own
   * tracking, this portal, or FreightSimple.
   *
   * @type {string}
   * @memberof TrackingLine
   */
  source?: string;
}

/**
 * Check if a given object implements the TrackingLine interface.
 */
export function instanceOfTrackingLine(value: object): value is TrackingLine {
  if (!("trackingLineId" in value) || value["trackingLineId"] === undefined)
    return false;
  if (!("message" in value) || value["message"] === undefined) return false;
  return true;
}

export function TrackingLineFromJSON(json: any): TrackingLine {
  return TrackingLineFromJSONTyped(json, false);
}

export function TrackingLineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrackingLine {
  if (json == null) {
    return json;
  }
  return {
    trackingLineId: json["trackingLineId"],
    message: json["message"],
    details: json["details"] == null ? undefined : json["details"],
    at: json["at"] == null ? undefined : json["at"],
    source: json["source"] == null ? undefined : json["source"],
  };
}

export function TrackingLineToJSON(json: any): TrackingLine {
  return TrackingLineToJSONTyped(json, false);
}

export function TrackingLineToJSONTyped(
  value?: TrackingLine | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingLineId: value["trackingLineId"],
    message: value["message"],
    details: value["details"],
    at: value["at"],
    source: value["source"],
  };
}
